
const Overview = () => {
   return (
      <div className="courses__overview-wrap">
         <h3 className="title">Course Description</h3>
         <p>Dorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.dolor sit amet, consectetur adipiscing elited do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
         <h3 className="title">What you&apos;ll learn in this course?</h3>
         <p>Dorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan.</p>
         <ul className="about__info-list list-wrap">
            <li className="about__info-list-item">
               <i className="flaticon-angle-right"></i>
               <p className="content">Work with color & Gradients & Grids</p>
            </li>
            <li className="about__info-list-item">
               <i className="flaticon-angle-right"></i>
               <p className="content">All the useful shortcuts</p>
            </li>
            <li className="about__info-list-item">
               <i className="flaticon-angle-right"></i>
               <p className="content">Be able to create Flyers, Brochures, Advertisements</p>
            </li>
            <li className="about__info-list-item">
               <i className="flaticon-angle-right"></i>
               <p className="content">How to work with Images & Text</p>
            </li>
         </ul>
         <p className="last-info">Morem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan.Dorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magn.</p>
      </div>
   )
}

export default Overview
